import { render, staticRenderFns } from "./Colunas.vue?vue&type=template&id=312f04e7&scoped=true"
import script from "./Colunas.vue?vue&type=script&lang=js"
export * from "./Colunas.vue?vue&type=script&lang=js"
import style0 from "./Colunas.vue?vue&type=style&index=0&id=312f04e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312f04e7",
  null
  
)

export default component.exports